import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Order } from '@alliance-disposal/transport-types';
import { titleCase } from '@wayste/client-utils';
import { Badge } from '@wayste/shadcn/components/badge';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@wayste/shadcn/components/dropdown-menu';
import { cn } from '@wayste/shadcn/lib/utils';
import { useSourContext } from '@wayste/sour-context';
import { useNavigate } from 'react-router-dom';
import { useRollOffDetailsRoutes } from './routes-context';
const popperOptionsAll = ['ON_HOLD', 'UNASSIGNED', 'ASSIGNED', 'DELIVERED', 'READY_FULL_PICKUP', 'DUMPED'];
const popperOptions = {
    UNASSIGNED: Order.SourgumOrderStatusLabels.UNASSIGNED,
    ASSIGNED: Order.SourgumOrderStatusLabels.ASSIGNED,
    DELIVERED: Order.SourgumOrderStatusLabels.DELIVERED,
    READY_FULL_PICKUP: Order.SourgumOrderStatusLabels.READY_FULL_PICKUP,
    DUMPED: Order.SourgumOrderStatusLabels.DUMPED,
};
const orderStatusOptions = Object.entries(popperOptions).map((item) => ({
    label: item[1],
    value: item[0],
}));
export const OrderStatusPopper = ({ order, onChange, navigateOnly, className, variant = 'default' }) => {
    const navigate = useNavigate();
    const routes = useRollOffDetailsRoutes();
    const [statusColor, setStatusColor] = useState('');
    const { useConfirmationDialog, godModeActive } = useSourContext();
    const { getConfirmation } = useConfirmationDialog();
    useEffect(() => {
        switch (order.status) {
            case 'NEEDS_REVIEW':
                setStatusColor('bg-statuses-NEEDS_REVIEW-primary text-statuses-NEEDS_REVIEW-text');
                break;
            case 'UNASSIGNED':
                setStatusColor('bg-statuses-UNASSIGNED-primary text-statuses-UNASSIGNED-text');
                break;
            case 'ON_HOLD':
                setStatusColor('bg-statuses-ON_HOLD-primary text-statuses-ON_HOLD-text');
                break;
            case 'ASSIGNED':
                setStatusColor('bg-statuses-ASSIGNED-primary text-statuses-ASSIGNED-text');
                break;
            case 'DELIVERED':
                setStatusColor('bg-statuses-DELIVERED-primary text-statuses-DELIVERED-text');
                break;
            case 'READY_FULL_PICKUP':
                setStatusColor('bg-statuses-READY_FULL_PICKUP-primary text-statuses-READY_FULL_PICKUP-text');
                break;
            case 'DUMPED':
                setStatusColor('bg-statuses-DUMPED-primary text-statuses-DUMPED-text');
                break;
            case 'COMPLETED':
                setStatusColor('bg-statuses-COMPLETED-primary text-statuses-COMPLETED-text');
                break;
            case 'CANCELLED':
                setStatusColor('bg-statuses-CANCELLED-primary text-statuses-CANCELLED-text');
                break;
            default:
                setStatusColor('');
                break;
        }
    }, [order.status]);
    const checkEnabled = (value) => {
        const currentIndex = popperOptionsAll.indexOf(order.status);
        const newIndex = popperOptionsAll.indexOf(value);
        if (godModeActive || (newIndex === popperOptionsAll.length - 1 && currentIndex === popperOptionsAll.length - 1)) {
            return true;
        }
        return newIndex < currentIndex || newIndex === currentIndex + 1;
    };
    const handleClick = async (e) => {
        if (order.status === 'NEEDS_REVIEW') {
            e.stopPropagation();
            const orderSwitch = order.switches.find((sw) => sw.toOrder === order.id);
            if (orderSwitch) {
                const result = await getConfirmation({
                    title: 'Switch Order',
                    message: 'This order is part of a Customer Portal Switch Request. Review the pickup request before the new delivery.',
                    confirmText: 'Review Pickup Order',
                });
                if (result) {
                    navigate(routes.orders.details(orderSwitch.fromOrder));
                }
            }
            else {
                if (routes.orders.review) {
                    navigate(routes.orders.review(order.id));
                }
            }
            return;
        }
        else if (navigateOnly) {
            navigate(routes.orders.details(order.id));
            return;
        }
    };
    const getTitle = () => {
        let text = Order.SourgumOrderStatusLabels[order.status];
        if (order.status === 'DUMPED')
            text = 'Enter Ticket';
        return text;
    };
    if (variant === 'shadcn') {
        return _jsx(Badge, { className: cn('w-full', className, statusColor), children: getTitle() });
    }
    // For NEEDS_REVIEW or navigateOnly, render a simple button without dropdown
    if (order.status === 'NEEDS_REVIEW' || navigateOnly) {
        return (_jsx("button", { className: `btn-base h-8 w-28 whitespace-nowrap rounded ${className} ${statusColor}`, type: "button", onClick: handleClick, children: getTitle() }));
    }
    return (_jsxs(DropdownMenu, { children: [_jsx(DropdownMenuTrigger, { asChild: true, children: _jsx("button", { className: `btn-base h-8 w-28 whitespace-nowrap rounded ${className} ${statusColor}`, type: "button", children: getTitle() }) }), _jsx(DropdownMenuContent, { children: orderStatusOptions.map((item) => (_jsx(DropdownMenuItem, { className: cn(item.value === order.status && 'bg-accent'), onClick: () => onChange?.(item.value), disabled: !checkEnabled(item.value), children: titleCase(item.label) }, item.value))) })] }));
};
//# sourceMappingURL=order-status-popper.js.map